var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_05-\\u5168\\u5C40\\u63D0\\u793A_\\u53CD\\u9988\\u56FE\\u6807",
    "data-name": "05-\\u5168\\u5C40\\u63D0\\u793A/\\u53CD\\u9988\\u56FE\\u6807",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u5360\\u4F4D",
    width: 20,
    height: 20,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle-filled"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "check-circle-filled_Background_",
    "data-name": "check-circle-filled (Background)",
    width: 20,
    height: 20,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check-circle-filled-2",
    "data-name": "check-circle-filled",
    d: "M8.75,17.5A8.75,8.75,0,1,1,17.5,8.75,8.76,8.76,0,0,1,8.75,17.5ZM5.258,8.125h0l-.883.883L7.5,12.134,13.125,6.51l-.884-.885L7.5,10.366,5.258,8.125Z",
    transform: "translate(1.25 1.25)",
    fill: "#00a870"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.72be94e09c038df96a9019e1bec5dd70.svg";
export { ForwardRef as ReactComponent };